import { render, staticRenderFns } from "./rulesets.vue?vue&type=template&id=596f3904&scoped=true"
import script from "./rulesets.vue?vue&type=script&lang=js"
export * from "./rulesets.vue?vue&type=script&lang=js"
import style0 from "./rulesets.vue?vue&type=style&index=0&id=596f3904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f3904",
  null
  
)

export default component.exports